export interface OnboardingOrganization {
  id: number
  name: string | null
  categoryIds: number[]
  stripeConnectId: string | null
}

export const defaultOrganizationOnboardingState = {
  id: 0,
  name: null,
  categoryIds: [],
  stripeConnectId: null,
}
